module.exports = __webpack_public_path__ + "static/media/logo-updated.9109a8dd.png";